// 트랙 9-5 GREEN — calc_code 산식 설명 정적 카탈로그 + 매칭 함수.
// 출처: docs/kpi/KPI_MASTER_SPEC.md §2 (사용 중 14종 + 사용자 결정 정규화 4건).
// 매칭 규칙 우선순위 (KPI_MASTER_SPEC §2-1):
//  (1) (P,A) AND name='공정 불량 건수 감소'        → RATE_QC_DEFECT
//  (2) (C,Z) AND name 포함 '폐기'                  → RATE_QC_DEFECT
//  (3) (C,E) AND name 포함 '작업공수'/'작업시간 감소' → WORK_HOURS_TOTAL
//  (4) (C,Z) AND name 포함 '교반'                  → WORK_HOURS_TOTAL
//  (5) (C,E) AND name='제조리드타임'              → LEADTIME_MFG
//  (6) (D,Z) AND name 포함 '수주출하'+'리드타임'    → LEADTIME_DELIVERY
//  (7) 그 외 → (fldCd, dtlCd) 기본 매핑

const D = (code, desc, unit, inputs) => ({ code, desc, unit, inputs });

export const KPI_CALC_CODE_DESCRIPTIONS = {
  RATE_OPERATION: D('RATE_OPERATION', '가동률 = 가동시간 / 총 가동가능시간 × 100', '%', ['machine_uptime']),
  RATE_QC_DEFECT: D('RATE_QC_DEFECT', '불량률 = SUM(progress.amount where type_code=2) / SUM(type_code=1) × 100', '%', ['progress']),
  COUNT_QC_DEFECT: D('COUNT_QC_DEFECT', '불량 건수 = SUM(progress.amount where type_code=2)', '수량', ['progress']),
  RATE_QC_RETURN: D('RATE_QC_RETURN', '반품률 = 반품수량 / 출하수량 × 100', '%', ['product_return']),
  COUNT_QC_DESIGN_CHG: D('COUNT_QC_DESIGN_CHG', '설계변경 건수 = COUNT(*)', '수량', ['design_change']),
  LEADTIME_DELIVERY: D('LEADTIME_DELIVERY', '납기 단축 = AVG(release_dt - contract_dt)', '일', ['contract']),
  RATE_DELIVERY_COMPLY: D('RATE_DELIVERY_COMPLY', '납기 준수율 = COUNT(release_dt <= due_dt) / COUNT(*) × 100', '%', ['contract']),
  LEADTIME_MFG: D('LEADTIME_MFG', '제조 리드타임 = AVG(readtime.readtime) / 3600', '시간', ['readtime']),
  SUM_PRODUCTION_QTY: D('SUM_PRODUCTION_QTY', '생산량 = SUM(progress.amount where type_code=1)', '수량', ['progress']),
  COUNT_PRODUCT_VARIETY: D('COUNT_PRODUCT_VARIETY', '생산 품목 수 = COUNT(DISTINCT product_in.product_seq where in_type_code=1)', '품목', ['product_in']),
  WORK_HOURS_TOTAL: D('WORK_HOURS_TOTAL', '작업시간 = SUM(work_hours.hours) (일/월 평균)', '시간', ['work_hours']),
  COST_INVENTORY: D('COST_INVENTORY', '재고비용 = max(0, in_value_cum - out_value_cum) (가중평균단가)', '원', ['material_in', 'material_out']),
  OTHER_PZ: D('OTHER_PZ', '기타 P/Z (회사별 자유 정의)', '자유', []),
  OTHER_DZ: D('OTHER_DZ', '기타 D/Z (회사별 자유 정의)', '자유', []),
};

// (fldCd,dtlCd) → calc_code 기본 매핑 (단독 결정 가능 케이스).
const BASE_MAP = {
  'P,A': 'RATE_OPERATION', 'P,B': 'SUM_PRODUCTION_QTY', 'P,C': 'LEADTIME_MFG',
  'P,E': 'COUNT_PRODUCT_VARIETY', 'P,Z': 'OTHER_PZ',
  'Q,A': 'COUNT_QC_DEFECT', 'Q,B': 'RATE_QC_DEFECT',
  'Q,D': 'RATE_QC_RETURN', 'Q,J': 'COUNT_QC_DESIGN_CHG',
  'D,A': 'LEADTIME_DELIVERY', 'D,C': 'LEADTIME_DELIVERY',
  'D,G': 'RATE_DELIVERY_COMPLY', 'D,Z': 'OTHER_DZ',
  'C,B': 'COST_INVENTORY', 'C,E': 'WORK_HOURS_TOTAL',
};

const has = (s, sub) => typeof s === 'string' && s.indexOf(sub) >= 0;
const desc = (key) => KPI_CALC_CODE_DESCRIPTIONS[key];

export function matchCalcCode(kpiFldCd, kpiDtlCd, indicatorName) {
  if (!kpiFldCd || !kpiDtlCd) return null;
  const f = String(kpiFldCd).toUpperCase();
  const d = String(kpiDtlCd).toUpperCase();
  const name = indicatorName || '';

  // 사용자 결정 정규화 — 우선 적용
  if (f === 'P' && d === 'A' && name === '공정 불량 건수 감소') return desc('RATE_QC_DEFECT');
  if (f === 'C' && d === 'Z' && has(name, '폐기')) return desc('RATE_QC_DEFECT');
  if (f === 'C' && d === 'E' && (has(name, '작업공수') || has(name, '작업시간 감소'))) return desc('WORK_HOURS_TOTAL');
  if (f === 'C' && d === 'Z' && has(name, '교반')) return desc('WORK_HOURS_TOTAL');
  if (f === 'C' && d === 'E' && name === '제조리드타임') return desc('LEADTIME_MFG');
  if (f === 'D' && d === 'Z' && has(name, '수주출하') && has(name, '리드타임')) return desc('LEADTIME_DELIVERY');

  // (fldCd, dtlCd) 기본 매핑
  const code = BASE_MAP[`${f},${d}`];
  return code ? desc(code) || null : null;
}
